import React from 'react'

const BlurOrangeDecorationLarge = () => {
    return (
        <div className='blur-orange-decoration-large'></div>
    )
}

export default BlurOrangeDecorationLarge